import ForwardTracker from "../../../../../prop-trackers/forward-tracker.js";
import ValueTracker from "../../../../../prop-trackers/value-tracker.js";
import PropTracker from "../../../../../prop-trackers/prop-tracker.js";
import { Mapper, ValueMapper } from "../../../../../prop-tracker-utils/mapper.js";

class PosScaleFilter extends ForwardTracker {
    constructor(coordTracker, wrapCtx, evtCtx) {
        const mapper = new Mapper(coordTracker, (key) => new FilterMapper(wrapCtx, evtCtx));
        super(mapper);
    }
}

const FilteredProps = new Set(["position", "scale"]);

class FilterMapper extends ValueMapper {
    constructor(wrapCtx, evtCtx) {
        super();

        this._evtCtx = evtCtx;

        this._filteredCoords = wrapCtx.getWrapper({});

        this._coordTracker = new PropTracker();
        this._outputTracker = new ValueTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._coordTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(fullCoords) {
        if (fullCoords) {
            this._coordTracker.track(fullCoords, this._evtCtx.getEvents(fullCoords));
            this._outputTracker.setValue(this._filteredCoords);
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._coordTracker.track();
        this._outputTracker.deleteValue();
    }

    protected_startUpdate() {
        this._coordTracker.update(({ props }) => {
            for (const { key, newExists, newValue } of props.iterateModified()) {
                if (FilteredProps.has(key)) {
                    if (newExists) {
                        this._filteredCoords[key] = newValue;
                    } else {
                        delete this._filteredCoords[key];
                    }
                }
            }
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._outputTracker.finishUpdate();
    }
}

export default PosScaleFilter;
